const isSuccessfulStreamStatus = status => status >= 200 && status < 400
const isDetachedStreamStatus = status => status === 0

module.exports = {
  isDetachedStreamStatus,
  isSuccessfulStreamStatus
}
